import { AppPageShell, GlobalNotAuthorized } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_auth/matters/settings")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.mattersSettings)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <Suspense fallback={<LawWorksLoader className="w-full" />}>
      <AppPageShell>
        <Outlet />
      </AppPageShell>
    </Suspense>
  );
}
